import React, { useRef, useEffect, useState } from 'react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import TabletImage from '../recursos/POS.png'; // Ajusta la ruta según tu estructura
import { setupScene } from '../componentes/3d/QPMINI_GRIDTEST';
import QPM1 from '../recursos/Cajero-cobro-quickpay.png';
import { Link } from 'react-router-dom';
import POSMovil from '../recursos/celular.jpg';
import POSBascula from '../recursos/Bascula.png';

//PARTES
import Parte1 from '../componentes/Privado/Parte1';
import POSEmpatica from '../componentes/Privado/POSEmpatica';
import NuevoQP from '../componentes/Privado/NuevoQP';
import Cajeros from '../componentes/Privado/Cajeros';
import Cajeros2 from '../componentes/Privado/Cajeros2';
import Interactive from '../componentes/Interactive';
import Banner from '../componentes/Privado/NuevoQP/Layout';
import Banner2 from '../componentes/Privado/NuevoQP/Banner2';
import { PresenceContext } from 'framer-motion';
import Presentation from '../componentes/Privado/NuevoQP/components/Presentation';
import PosEmpatica2 from '../componentes/Privado/PosEmpatica2';
import EmpaticaDescription from '../componentes/camino/EmpaticaDescription';
import ConexionEmpatica from '../componentes/ConexionEmpatica';
import Banner3 from '../componentes/Privado/NuevoQP/Banner3';
import Accesorios from '../componentes/Privado/Accesorios';
import Footer from '../componentes/Privado/Footer';
import ChatWidget from '../componentes/ChatWidget';



//PARTES

gsap.registerPlugin(ScrollTrigger);

const Privado = () => {


    useEffect(() => {
        // const cleanup = setupScene(mountRef);
        //return cleanup;
    }, []);


    const [currentSlide, setCurrentSlide] = useState(0);
    const trail = ["box1", "box2", "box3", "box4", "box5"];

    const [animationTyping, setIsAnimationTyping] = useState(false);

    useEffect(() => {
        // Animación para mostrar la cortina
        gsap.fromTo(".curtain",
            { y: '-100%' },
            { y: '0%', duration: 0, ease: 'power2.inOut' } //duration: 1 es el original
        );

        setTimeout(() => {
            setIsAnimationTyping(true)
        }, 1000)

    }, []);


    return (
        <>
            <Presentation />
            <Banner3/>


            
            {/*<Banner2 />*/}
            
            {/*<NuevoQP />*/}
           

{/*
            <div className="min-h-screen bg-[#1a1f2b] text-white font-sans flex items-center justify-center">

                <div className="w-full h-screen bg-[#232833]  p-10 relative overflow-hidden shadow-xl flex">
         
                    <div className="absolute right-10 top-1/2 transform -translate-y-1/2 w-[400px] h-[400px] bg-[#ffffff99] rounded-full blur-[200px] z-0"></div>


     
                    <div className="flex-1 z-10 pr-12 relative">
                        <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-700"></div>

                        <div className="space-y-6">
                            <div>
                                <p className="text-sm text-gray-400 uppercase mb-2">Medidas del producto</p>
                                <p className="text-sm text-gray-300 leading-relaxed">
                                Gabinete principal: 65 cm (alto) x 38 cm (ancho) x 31 cm (fondo).<br />
                                Módulo adicional (lector, checador, etc.): dimensiones variadas desde 4 a 22 cm.
                                </p>
                            </div>

                            <div>
                                <p className="text-sm text-gray-400 uppercase mb-2">Descripcion del producto</p>
                                <p className="text-base text-white leading-relaxed">
                                    A pocket-sized device that allows consumers to test toxic chemicals in their food. This device uses a colorimetric method to detect the presence of nitrates in meat, vegetables, and other food products.
                                </p>
                            </div>

                            <div>
                                <p className="text-sm text-gray-400 uppercase mb-2">Capacidad del producto</p>
                                <div className="flex gap-4">
                                    <button className="px-4 py-1 border border-gray-600 rounded-full text-sm text-gray-300 hover:bg-gray-700">💵 600 billetes, acepta y recicla 6 denominaciones</button>
                                    <button className="px-4 py-1 border border-gray-600 rounded-full text-sm text-gray-300 hover:bg-gray-700">🪙 600 monedas, reciclaje de 6 denominaciones</button>

                                </div>
                            </div>

                            <div>
                                <p className="text-sm text-gray-400 uppercase mb-2">Size / Package Dimensions</p>
                                <p className="text-sm text-gray-300">3.9” x 1.3” x 0.8” / 10 x 3.4 x 2 cm</p>
                            </div>

                            <div>
                                <p className="text-sm text-gray-400 uppercase mb-2">Color</p>
                                <div className="flex gap-3">
                                    <span className="w-5 h-5 rounded-full bg-gray-300"></span>
                                    <span className="w-5 h-5 rounded-full bg-gray-500"></span>
                                    <span className="w-5 h-5 rounded-full bg-gray-800"></span>
                                </div>
                            </div>
                        </div>
                    </div>

            
                    <div className="flex-1 flex flex-col items-center justify-center z-10">
                        <img
                            src={QPM1}
                            alt="Device Side"
                            className="h-100 mb-10 drop-shadow-xl"
                        />
                    </div>
                </div>
            </div>
*/
}

            {/*<Cajeros />*/}

            <POSEmpatica/>
            <Accesorios/>
            <ConexionEmpatica />
            {/*  <ChatWidget />*/}
            <Footer />

           {/*<section
                style={{
                    height: '100vh',
                    backgroundColor: 'green',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <h1 style={{ color: '#fff' }}>Sección 7</h1>
            </section>*/}
        </>
    );
};

export default Privado;
